import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import _ from 'underscore';
import * as Icon from 'react-icons/fi';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';

import Datagrid from 'ui/components/data/grid';
import CustomerForm from './component/form';
import DetailLayout from './detail.layout';
import { Customer } from 'services/action';

const initialState = {
  data: null,
  showDelete: false,
  showUpdate: false,
  privilege: null,
};

const Action = ({ loading, data, handleUpdated, privilege }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Customer.Delete']
  );
  const [{ showDelete, showUpdate }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showDelete: false,
      showUpdate: false,
      isDefault: false,
    }));

    handleUpdated(data?.id);
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Customer.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
    }
  };

  if (loading) return null;

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id={`tooltip-top`}>Kembali</Tooltip>}
      >
        <Link to={`/master/customer`} className="btn btn-secondary px-2">
          <Icon.FiChevronsLeft size="17" />
        </Link>
      </OverlayTrigger>
      {privilege && (
        <>
          <button
            className="btn btn-primary py-1"
            onClick={() =>
              setState((prevState) => ({ ...prevState, showUpdate: true }))
            }
          >
            <Icon.FiEdit color="white" size="14" />
            <span className="d-none d-md-block ms-2">Perbaharui Data</span>
          </button>
          <button
            className="btn btn-danger py-1"
            onClick={() =>
              setState((prevState) => ({ ...prevState, showDelete: true }))
            }
          >
            <Icon.FiTrash2 color="white" size="14" />
            <span className="d-none d-md-block ms-2">Hapus Customer</span>
          </button>
        </>
      )}

      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Icon.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin akan menghapus data customer ?</h3>
          <p className="text-danger fw-semibold">
            Semua data customer akan terhapus secara permanen, dan data yang
            sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateLoading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUpdate}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Customer</Modal.Title>
        </Modal.Header>
        <CustomerForm onClose={$handleClose} data={data} />
      </Modal>
    </>
  );
};

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Customer.Show']
  );

  const [{ data, privilege }, setState] = React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(Customer.$show(id));
    if (req?.message === 'success' && req?.data) {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    } else {
      History.push(`/master/customer`);
    }
  };

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.partner',
    });

    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  return (
    <DetailLayout
      customer_id={data?.id}
      action={
        <Action
          handleUpdated={$onLoad}
          loading={StateLoading}
          data={data}
          privilege={privilege?.action === 'manage' || !Session?.privileges}
        />
      }
    >
      <div className="row p-3">
        <div className="col-md-12 mt-3 mb-4">
          <div className="row flex-wrap">
            <div className="col-md-6">
              <div className="datagrid">
                <Datagrid
                  loading={StateLoading}
                  title="Entitier"
                  value={data?.entities}
                />
                <Datagrid
                  loading={StateLoading}
                  title="Nama Customer"
                  value={data?.name}
                />
              </div>
            </div>
            <div className="col-md-6 mt-3 mt-md-0">
              <div className="datagrid">
                <Datagrid
                  loading={StateLoading}
                  title="Perusahaan"
                  value={data?.company_name}
                />
                <Datagrid
                  loading={StateLoading}
                  title="Alamat"
                  value={data?.address || '-'}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Data Penanggung Jawab
          </div>
          <div className="datagrid">
            <Datagrid
              loading={StateLoading}
              title="Nama"
              value={data?.pic_name || '-'}
            />
            <Datagrid
              loading={StateLoading}
              title="Telpon"
              value={data?.pic_phone || '-'}
            />
            <Datagrid
              loading={StateLoading}
              title="Email"
              value={data?.pic_email || '-'}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Data Finance
          </div>
          <div className="datagrid">
            <Datagrid
              loading={StateLoading}
              title="Nama"
              value={data?.finance_name || '-'}
            />
            <Datagrid
              loading={StateLoading}
              title="Telpon"
              value={data?.finance_phone || '-'}
            />
            <Datagrid
              loading={StateLoading}
              title="Email"
              value={
                data?.finance_emails?.map((e) => (
                  <div className='flex-column'>
                    {e}
                  </div>
                ))
              }
            />
          </div>
        </div>
      </div>
    </DetailLayout>
  );
};

export default DetailScreen;
